import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Container } from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import Button from '../../atoms/Button'

import TitleBar from '../../atoms/TitleBar'
import { makeTranslationAware } from '../../../utils'

const ContainerStatic = styled(Container)`
  height: calc(100% - 5rem);
  margin-top: 5rem;
  padding-bottom: 4rem;
  overflow-y: auto;
`

const Centralize = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`

const Title = makeTranslationAware(styled.span`
  color: ${({ theme }) => theme.colors.secondary };
  font-size: 2.5rem;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  max-width: 29rem;
`)

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 32px;
`


const Details = makeTranslationAware(styled.p`
    font-size: 17px;
    text-align: center;
    padding-bottom: 4rem;
`)


class Success extends PureComponent {
  render() {
    return (
      <ContainerStatic>
        <Centralize>
          <TitleContainer>
            <Title>
              menu.contact.success
            </Title>
          </TitleContainer>
          <Details>
            form.thanks
          </Details>
          <Button href="/" target="_self">
            go.to.home
          </Button>
        </Centralize>
      </ContainerStatic>
    )
  }
}

export default Success



// WEBPACK FOOTER //
// ./src/components/templates/ContactUs/Success.js